import EditorInput from './EditorInput';

export default EditorInput;
